import { render, staticRenderFns } from "./CouponsDivulgation.vue?vue&type=template&id=0697b12f&scoped=true&"
import script from "./CouponsDivulgation.vue?vue&type=script&lang=js&"
export * from "./CouponsDivulgation.vue?vue&type=script&lang=js&"
import style0 from "./CouponsDivulgation.vue?vue&type=style&index=0&id=0697b12f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0697b12f",
  null
  
)

export default component.exports